import { render, staticRenderFns } from "./IsBankasiHGSCancelView.vue?vue&type=template&id=5b7024f8&"
import script from "./IsBankasiHGSCancelView.vue?vue&type=script&lang=js&"
export * from "./IsBankasiHGSCancelView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports